import { render } from "./PerformanceComparePopup.vue?vue&type=template&id=bf931d98&scoped=true"
import script from "./PerformanceComparePopup.vue?vue&type=script&lang=js"
export * from "./PerformanceComparePopup.vue?vue&type=script&lang=js"

import "./PerformanceComparePopup.vue?vue&type=style&index=0&id=bf931d98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf931d98"],['__file',"src/containers/performance/PerformanceComparePopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf931d98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf931d98', __exports__)) {
    api.reload('bf931d98', __exports__)
  }
  
  module.hot.accept("./PerformanceComparePopup.vue?vue&type=template&id=bf931d98&scoped=true", () => {
    api.rerender('bf931d98', render)
  })

}


export default __exports__